<template>
  <SAIPageWrapper :pad-x="false">
    <CarSearchTabs />
    <div class="row q-mt-md justify-center text-weight-bold">
      <p>We found</p>
      <p class="text-primary q-px-xs">{{ variants.length }}</p>
      <p>matches</p>
    </div>
    <SAICarousel
      :value="displayCard"
      @input="$emit('update:display-card', $event)"
      infinite
      swipeable
      arrows
      animated
      height="100%"
      class="list-of-car"
      ref="carousel"
      v-if="variants.length > 0"
    >
      <QCarouselSlide
        v-for="(variant, index) in variants"
        :key="index"
        :name="index"
        class="text-center"
      >
        <VariantCard
          :loading="saving"
          :disable="disable"
          :cardDetail="variant"
          :currentCard="index + 1"
          :numberOfCards="variants.length"
        >
          <div
            v-if="displayUsedCarFields"
            class="q-mt-lg row q-col-gutter-x-sm"
          >
            <SAIFormError class="q-mt-md" v-if="errors.$error && errors.$dirty" />
            <SAIFormLabel class="text-left">Car is from a</SAIFormLabel>
            <div
              v-for="option in carIsFromOptions"
              :key="option.value"
              class="col-6"
            >
              <SAICardToggle
                :disable="disable"
                class="q-py-md q-px-lg items-center"
                :active="option.value === carIsFrom"
                :error="errors.carIsFrom.$error"
                @click="$emit('update:car-is-from', option.value)"
              >
                <span class="text-weight-medium text-no-wrap text-paragraph">
                  {{ option.label }}
                </span>
              </SAICardToggle>
            </div>
          </div>
          <div v-if="displayUsedCarFields" class="q-mt-lg">
            <SAIFormLabel class="text-left">Current Odometer*</SAIFormLabel>
            <SAIInput
              :disable="disable"
              :error="errors.odometer.$error"
              :value="odometer"
              type="number"
              @input="$emit('update:odometer', $event)"
            />
          </div>
          <div v-if="displayUsedCarFields" class="q-mt-lg">
            <SAIFormLabel class="text-left">
              Estimated market value*
            </SAIFormLabel>
            <SAIInput
              :disable="disable"
              :error="errors.carPrice.$error"
              prefix="$"
              :value="carPrice"
              type="number"
              @input="$emit('update:price', $event)"
            />
          </div>
          <div class="column q-gutter-y-sm q-mt-lg">
            <div
              class="row justify-center"
              v-for="(action, index) in actions"
              :key="index"
            >
              <SAIBtn
                :disable="disable"
                :loading="action.loading"
                :label="action.label"
                no-caps
                :class="[
                  'cursor-pointer justify-center',
                  { 'col-12': $q.screen.lt.sm }
                ]"
                @click="action.action"
              />
            </div>
          </div>
        </VariantCard>
      </QCarouselSlide>
    </SAICarousel>
    <div class="row justify-center q-mt-lg">
      <SAIBtn
        label="Back to search"
        no-caps
        :disable="disable"
        padding="12px xl"
        @click="$emit('back')"
      />
    </div>
  </SAIPageWrapper>
</template>
<script>
import {
  SAICarousel,
  SAIPageWrapper,
  SAIBtn,
  SAIFormLabel,
  SAIInput,
  SAICardToggle,
  SAIFormError
} from 'ecx.saigon.ui.common';
import { QCarouselSlide } from 'quasar';

export default {
  name: 'CarSearchVariant',
  props: {
    saving: Boolean,
    disable: Boolean,
    displayUsedCarFields: Boolean,
    odometer: undefined,
    carPrice: undefined,
    variants: {
      type: Array,
      default: () => []
    },
    actions: {
      type: Array,
      default: () => []
    },
    errors: {
      type: Object,
      default: () => ({})
    },
    displayCard: {
      type: Number
    },
    carIsFromOptions: {
      type: Array,
      default: () => []
    },
    carIsFrom: String
  },
  components: {
    SAIPageWrapper,
    SAICarousel,
    QCarouselSlide,
    SAIBtn,
    SAIFormLabel,
    SAIInput,
    SAICardToggle,
    SAIFormError,
    VariantCard: () => import('../../organism/variant-card'),
    CarSearchTabs: () => import('../../../widgets/car-search-tabs')
  }
};
</script>

<style lang="sass" scoped>
.list-of-car::v-deep
  .q-carousel__prev-arrow--horizontal,
  .q-carousel__next-arrow--horizontal
    top: 100px
    bottom: initial
    background: white
  .q-carousel__slide
    padding: 0 16px
</style>
